(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"]) return;
  try {
    
   let stores = [{
    "recommendation": {},
    "storeNumber": "5758-13907",
    "id": "15051",
    "name": "La Cienega & Gregory Way",
    "phoneNumber": "310-659-9562",
    "coordinates": {
        "latitude": 34.063584,
        "longitude": -118.376354
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "257 S. La Cienega Blvd.",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "Beverly Hills",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "902113301"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": true,
    "openStatusText": "Open until 6:00 PM",
    "addressLines": ["257 S. La Cienega Blvd.", "Beverly Hills, CA 90211"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "VS",
        "name": "Verismo"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "GO",
        "name": "Google Wi-Fi"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "MX",
        "name": "Music Experience"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "PS",
        "name": "Playbook Store System"
    }, {
        "code": "WC",
        "name": "Wireless Charging"
    }, {
        "code": "UE",
        "name": "tbd - Uber Eats"
    }],
    "slug": "la-cienega-gregory-way-257-s-la-cienega-blvd-beverly-hills-ca-902113301-u"
}, {
    "recommendation": {},
    "storeNumber": "5577-1851",
    "id": "14753",
    "name": "Fairfax & Olympic",
    "phoneNumber": "(323) 634-7845",
    "coordinates": {
        "latitude": 34.057968,
        "longitude": -118.363715
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "6066 West Olympic Boulevard",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "Los Angeles",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900364402"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": true,
    "openStatusText": "Open until 6:00 PM",
    "addressLines": ["6066 West Olympic Boulevard", "Los Angeles, CA 90036"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "VS",
        "name": "Verismo"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "GO",
        "name": "Google Wi-Fi"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "MX",
        "name": "Music Experience"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "PS",
        "name": "Playbook Store System"
    }, {
        "code": "UE",
        "name": "tbd - Uber Eats"
    }],
    "slug": "fairfax-olympic-6066-west-olympic-boulevard-los-angeles-ca-9003644"
}, {
    "recommendation": {},
    "storeNumber": "16279-169147",
    "id": "114059",
    "name": "Target LA Beverly T-2775",
    "phoneNumber": "323-602-0637",
    "coordinates": {
        "latitude": 34.07526,
        "longitude": -118.375571
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "8480 Beverly Blvd",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "Los Angeles",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900483414"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "LS",
    "open": true,
    "openStatusText": "Open until 9:00 PM",
    "addressLines": ["8480 Beverly Blvd", "Los Angeles, CA 90048"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "8:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "8:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "8:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "8:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "8:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "8:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "8:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "WF",
        "name": "Wireless Hotspot"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "RW",
        "name": "My Starbucks Rewards"
    }],
    "slug": "target-la-beverly-t-2775-8480-beverly-blvd-los-angeles-ca-900483414-us"
}, {
    "recommendation": {},
    "storeNumber": "75244-90562",
    "id": "9620",
    "name": "Cedars-Sinai Medical Center",
    "phoneNumber": "310-423-6260",
    "coordinates": {
        "latitude": 34.075081,
        "longitude": -118.380376
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "8700 Beverly Blvd.",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "Los Angeles",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900481804"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "LS",
    "open": true,
    "openStatusText": "Open until 5:00 PM",
    "addressLines": ["8700 Beverly Blvd.", "Los Angeles, CA 90048"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "6:00 AM to 5:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "6:00 AM to 3:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "4:00 AM to 10:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "4:00 AM to 10:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "4:00 AM to 10:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "4:00 AM to 10:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "4:00 AM to 10:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "BA",
        "name": "Bakery"
    }],
    "slug": "cedars-sinai-medical-center-8700-beverly-blvd-los-angeles-ca-900481804-us"
}, {
    "recommendation": {},
    "storeNumber": "12900-154604",
    "id": "19370",
    "name": "Wilshire & Curson",
    "phoneNumber": "323-931-1013",
    "coordinates": {
        "latitude": 34.062657,
        "longitude": -118.35389
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "5757 Wilshire Blvd",
        "streetAddressLine2": "#106",
        "streetAddressLine3": null,
        "city": "Los Angeles",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900365810"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": true,
    "openStatusText": "Open until 6:00 PM",
    "addressLines": ["5757 Wilshire Blvd", "#106", "Los Angeles, CA 90036"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "CL",
        "name": "Starbucks Reserve-Clover Brewed"
    }, {
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "VS",
        "name": "Verismo"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "GO",
        "name": "Google Wi-Fi"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "MX",
        "name": "Music Experience"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "WC",
        "name": "Wireless Charging"
    }, {
        "code": "UE",
        "name": "tbd - Uber Eats"
    }],
    "slug": "wilshire-curson-5757-wilshire-blvd-los-angeles-ca-900365810-us"
}, {
    "recommendation": {},
    "storeNumber": "22415-184968",
    "id": "1006844",
    "name": "Ralphs Los Angeles #289",
    "phoneNumber": "323-936-4954",
    "coordinates": {
        "latitude": 34.062884,
        "longitude": -118.350934
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "5601 Wilshire Blvd",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "Los Angeles",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "90036"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "LS",
    "open": true,
    "openStatusText": "Open until 9:00 PM",
    "addressLines": ["5601 Wilshire Blvd", "Los Angeles, CA 90036"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "5:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "5:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "5:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "5:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "5:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "5:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "5:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "DR",
        "name": "Digital Rewards"
    }],
    "slug": "ralphs-los-angeles-289-5601-wilshire-blvd-los-angeles-ca-90036-us"
}, {
    "recommendation": {},
    "storeNumber": "5871-30359",
    "id": "15639",
    "name": "Beverly & Robertson",
    "phoneNumber": "310-659-7370",
    "coordinates": {
        "latitude": 34.076993,
        "longitude": -118.383543
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "164 N. Robertson",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "West Hollywood",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900483109"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": true,
    "openStatusText": "Open until 6:00 PM",
    "addressLines": ["164 N. Robertson", "West Hollywood, CA 90048"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "WF",
        "name": "Wireless Hotspot"
    }, {
        "code": "VS",
        "name": "Verismo"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "MX",
        "name": "Music Experience"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "PS",
        "name": "Playbook Store System"
    }, {
        "code": "WC",
        "name": "Wireless Charging"
    }, {
        "code": "UE",
        "name": "tbd - Uber Eats"
    }],
    "slug": "beverly-robertson-164-n-robertson-west-hollywood-ca-900483109-us"
}, {
    "recommendation": {},
    "storeNumber": "5626-1958",
    "id": "16379",
    "name": "Pico & Robertson",
    "phoneNumber": "310-860-9364",
    "coordinates": {
        "latitude": 34.054929,
        "longitude": -118.38354
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "8783 West Pico Blvd",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "Los Angeles",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900352212"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": true,
    "openStatusText": "Open until 6:00 PM",
    "addressLines": ["8783 West Pico Blvd", "Los Angeles, CA 90035"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "VS",
        "name": "Verismo"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "GO",
        "name": "Google Wi-Fi"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "MX",
        "name": "Music Experience"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "PS",
        "name": "Playbook Store System"
    }, {
        "code": "WC",
        "name": "Wireless Charging"
    }, {
        "code": "UE",
        "name": "tbd - Uber Eats"
    }],
    "slug": "pico-robertson-8783-west-pico-blvd-los-angeles-ca-900352212-us"
}, {
    "recommendation": {},
    "storeNumber": "671-312",
    "id": "12165",
    "name": "Olympic & Doheny",
    "phoneNumber": "(310) 275-0253",
    "coordinates": {
        "latitude": 34.059476,
        "longitude": -118.389593
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "9049 Olympic Blvd.",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "Beverly Hills",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "902113541"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": true,
    "openStatusText": "Open until 6:00 PM",
    "addressLines": ["9049 Olympic Blvd.", "Beverly Hills, CA 90211"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "VS",
        "name": "Verismo"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "GO",
        "name": "Google Wi-Fi"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "MX",
        "name": "Music Experience"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "PS",
        "name": "Playbook Store System"
    }, {
        "code": "WC",
        "name": "Wireless Charging"
    }, {
        "code": "UE",
        "name": "tbd - Uber Eats"
    }],
    "slug": "olympic-doheny-9049-olympic-blvd-beverly-hills-ca-902113541-us"
}, {
    "recommendation": {},
    "storeNumber": "9998-98124",
    "id": "7232",
    "name": "Wilshire & Detroit",
    "phoneNumber": "(323) 939-2071",
    "coordinates": {
        "latitude": 34.062516,
        "longitude": -118.345364
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "5353 Wilshire Blvd.",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "Los Angeles",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900364284"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": true,
    "openStatusText": "Open until 6:00 PM",
    "addressLines": ["5353 Wilshire Blvd.", "Los Angeles, CA 90036"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "WF",
        "name": "Wireless Hotspot"
    }, {
        "code": "VS",
        "name": "Verismo"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "MX",
        "name": "Music Experience"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "PS",
        "name": "Playbook Store System"
    }, {
        "code": "WC",
        "name": "Wireless Charging"
    }, {
        "code": "UE",
        "name": "tbd - Uber Eats"
    }],
    "slug": "wilshire-detroit-5353-wilshire-blvd-los-angeles-ca-900364284-us"
}, {
    "recommendation": {},
    "storeNumber": "624-346",
    "id": "11488",
    "name": "Melrose & Stanley",
    "phoneNumber": "323-852-9690",
    "coordinates": {
        "latitude": 34.083427,
        "longitude": -118.356145
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "7624 Melrose Avenue",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "Los Angeles",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900467420"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": true,
    "openStatusText": "Open until 6:00 PM",
    "addressLines": ["7624 Melrose Avenue", "Los Angeles, CA 90046"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "VS",
        "name": "Verismo"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "GO",
        "name": "Google Wi-Fi"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "MX",
        "name": "Music Experience"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "PS",
        "name": "Playbook Store System"
    }, {
        "code": "UE",
        "name": "tbd - Uber Eats"
    }],
    "slug": "melrose-stanley-7624-melrose-avenue-los-angeles-ca-900467420-us"
}, {
    "recommendation": {},
    "storeNumber": "28051-249448",
    "id": "1014988",
    "name": "La Cienega and Airdrome",
    "phoneNumber": "323-333-1529",
    "coordinates": {
        "latitude": 34.046133,
        "longitude": -118.376175
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "1742 S. La Cienega",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "Los Angeles",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900354602"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": true,
    "openStatusText": "Open until 11:00 PM",
    "addressLines": ["1742 S. La Cienega", "Los Angeles, CA 90035"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "4:00 AM to 11:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "4:00 AM to 11:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "4:00 AM to 11:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "4:00 AM to 11:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "4:00 AM to 11:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "4:00 AM to 11:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "4:00 AM to 11:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "DT",
        "name": "Drive-Thru"
    }, {
        "code": "CL",
        "name": "Starbucks Reserve-Clover Brewed"
    }, {
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "VS",
        "name": "Verismo"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "GO",
        "name": "Google Wi-Fi"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "MX",
        "name": "Music Experience"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "RW",
        "name": "My Starbucks Rewards"
    }, {
        "code": "PS",
        "name": "Playbook Store System"
    }, {
        "code": "CS",
        "name": "tbd - Coffee Scale"
    }, {
        "code": "UE",
        "name": "tbd - Uber Eats"
    }],
    "slug": "la-cienega-and-airdrome-1742-s-la-cienega-los-angeles-ca-900354602-us"
}, {
    "recommendation": {},
    "storeNumber": "28131-250071",
    "id": "1016399",
    "name": "4th and La Brea",
    "phoneNumber": "(323) 627-5619",
    "coordinates": {
        "latitude": 34.06716,
        "longitude": -118.344308
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "359 South La Brea",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "Los Angeles",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900363540"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": true,
    "openStatusText": "Open until 6:00 PM",
    "addressLines": ["359 South La Brea", "Los Angeles, CA 90036"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "CL",
        "name": "Starbucks Reserve-Clover Brewed"
    }, {
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "GO",
        "name": "Google Wi-Fi"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "RW",
        "name": "My Starbucks Rewards"
    }, {
        "code": "PS",
        "name": "Playbook Store System"
    }],
    "slug": "4th-and-la-brea-359-south-la-brea-los-angeles-ca-900363540-us"
}, {
    "recommendation": {},
    "storeNumber": "25200-156784",
    "id": "1014696",
    "name": "Ralph's-Los Angeles, CA #39",
    "phoneNumber": "323-937-3264",
    "coordinates": {
        "latitude": 34.070017,
        "longitude": -118.343501
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "260 S La Brea Ave",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "Los Angeles",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900363023"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "LS",
    "open": true,
    "openStatusText": "Open until 9:00 PM",
    "addressLines": ["260 S La Brea Ave", "Los Angeles, CA 90036"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "5:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "5:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "5:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "5:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "5:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "5:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "5:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }],
    "slug": "ralphs-los-angeles-ca-39-260-s-la-brea-ave-los-angeles-ca-900363023-us"
}, {
    "recommendation": {},
    "storeNumber": "5373-931",
    "id": "13336",
    "name": "Beverly & Detroit",
    "phoneNumber": "(323) 939-1793",
    "coordinates": {
        "latitude": 34.07597,
        "longitude": -118.344996
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "7122 Beverly Boulevard",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "Los Angeles",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900362569"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": true,
    "openStatusText": "Open until 6:00 PM",
    "addressLines": ["7122 Beverly Boulevard", "Los Angeles, CA 90036"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "VS",
        "name": "Verismo"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "GO",
        "name": "Google Wi-Fi"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "MX",
        "name": "Music Experience"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "PS",
        "name": "Playbook Store System"
    }, {
        "code": "WC",
        "name": "Wireless Charging"
    }, {
        "code": "UE",
        "name": "tbd - Uber Eats"
    }],
    "slug": "beverly-detroit-7122-beverly-boulevard-los-angeles-ca-900362569-us"
}, {
    "recommendation": {},
    "storeNumber": "5232-248024",
    "id": "1014392",
    "name": "Santa Monica & Robertson",
    "phoneNumber": "8584729420",
    "coordinates": {
        "latitude": 34.084089,
        "longitude": -118.385887
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "8951 Santa Monica Blvd.",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "West Hollywood",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900694923"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": true,
    "openStatusText": "Open until 6:00 PM",
    "addressLines": ["8951 Santa Monica Blvd.", "West Hollywood, CA 90069"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "GO",
        "name": "Google Wi-Fi"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "MX",
        "name": "Music Experience"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "PS",
        "name": "Playbook Store System"
    }, {
        "code": "WC",
        "name": "Wireless Charging"
    }, {
        "code": "UE",
        "name": "tbd - Uber Eats"
    }],
    "slug": "santa-monica-robertson-8951-santa-monica-blvd-west-hollywood-ca-900694923"
}, {
    "recommendation": {},
    "storeNumber": "3575-126987",
    "id": "9991",
    "name": "Von's-West Hollywood #2739",
    "phoneNumber": "(310) 595-1737",
    "coordinates": {
        "latitude": 34.083722,
        "longitude": -118.386627
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "8969 Santa Monica Blvd.",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "West Hollywood",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900694934"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "LS",
    "open": true,
    "openStatusText": "Open until 9:00 PM",
    "addressLines": ["8969 Santa Monica Blvd.", "West Hollywood, CA 90069"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "5:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "5:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "6:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "6:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "6:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "6:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "6:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "WF",
        "name": "Wireless Hotspot"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "BA",
        "name": "Bakery"
    }, {
        "code": "RW",
        "name": "My Starbucks Rewards"
    }],
    "slug": "vons-west-hollywood-2739-8969-santa-monica-blvd-west-hollywood-ca-900694934"
}, {
    "recommendation": {},
    "storeNumber": "633-351",
    "id": "14828",
    "name": "Santa Monica & Westmount",
    "phoneNumber": "(310) 659-1856",
    "coordinates": {
        "latitude": 34.088283,
        "longitude": -118.379078
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "8595 Santa Monica Blvd.",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "West Hollywood",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900694120"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": true,
    "openStatusText": "Open until 6:00 PM",
    "addressLines": ["8595 Santa Monica Blvd.", "West Hollywood, CA 90069"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "VS",
        "name": "Verismo"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "GO",
        "name": "Google Wi-Fi"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "MX",
        "name": "Music Experience"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "PS",
        "name": "Playbook Store System"
    }, {
        "code": "WC",
        "name": "Wireless Charging"
    }, {
        "code": "UE",
        "name": "tbd - Uber Eats"
    }],
    "slug": "santa-monica-westmount-8595-santa-monica-blvd-west-hollywood-ca-900694120"
}, {
    "recommendation": {},
    "storeNumber": "5257-292",
    "id": "16545",
    "name": "S. Beverly & Charleville",
    "phoneNumber": "(310) 271-2133",
    "coordinates": {
        "latitude": 34.064608,
        "longitude": -118.39884
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "202 South Beverly Drive",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "Beverly Hills",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "902123805"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": true,
    "openStatusText": "Open until 6:00 PM",
    "addressLines": ["202 South Beverly Drive", "Beverly Hills, CA 90212"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "WF",
        "name": "Wireless Hotspot"
    }, {
        "code": "VS",
        "name": "Verismo"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "MX",
        "name": "Music Experience"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "PS",
        "name": "Playbook Store System"
    }, {
        "code": "WC",
        "name": "Wireless Charging"
    }, {
        "code": "UE",
        "name": "tbd - Uber Eats"
    }],
    "slug": "s-beverly-charleville-202-south-beverly-drive-beverly-hills-ca-902123805"
}, {
    "recommendation": {},
    "storeNumber": "5698-291098",
    "id": "1024882",
    "name": "La Brea & Dockweiler",
    "phoneNumber": "3239342408",
    "coordinates": {
        "latitude": 34.051709,
        "longitude": -118.343924
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "1250 S. La Brea Ave",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "Los Angeles",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "90019"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": true,
    "openStatusText": "Open until 11:00 PM",
    "addressLines": ["1250 S. La Brea Ave", "Los Angeles, CA 90019"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "4:30 AM to 11:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "4:30 AM to 11:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "4:30 AM to 11:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "4:30 AM to 11:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "4:30 AM to 11:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "4:30 AM to 11:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "4:30 AM to 11:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "DT",
        "name": "Drive-Thru"
    }, {
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "GO",
        "name": "Google Wi-Fi"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "MX",
        "name": "Music Experience"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "RW",
        "name": "My Starbucks Rewards"
    }, {
        "code": "PS",
        "name": "Playbook Store System"
    }, {
        "code": "CS",
        "name": "tbd - Coffee Scale"
    }, {
        "code": "WC",
        "name": "Wireless Charging"
    }, {
        "code": "UC",
        "name": "tbd - UCP"
    }, {
        "code": "UE",
        "name": "tbd - Uber Eats"
    }],
    "slug": "la-brea-dockweiler-1250-s-la-brea-ave-los-angeles-ca-90019-us"
}, {
    "recommendation": {},
    "storeNumber": "5488-1453",
    "id": "8668",
    "name": "Wilshire & Highland",
    "phoneNumber": "(323) 936-2989",
    "coordinates": {
        "latitude": 34.061907,
        "longitude": -118.338895
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "5020 Wilshire Blvd.",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "Los Angeles",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900364315"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": true,
    "openStatusText": "Open until 6:00 PM",
    "addressLines": ["5020 Wilshire Blvd.", "Los Angeles, CA 90036"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "GO",
        "name": "Google Wi-Fi"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "MX",
        "name": "Music Experience"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "PS",
        "name": "Playbook Store System"
    }, {
        "code": "WC",
        "name": "Wireless Charging"
    }, {
        "code": "UE",
        "name": "tbd - Uber Eats"
    }],
    "slug": "wilshire-highland-5020-wilshire-blvd-los-angeles-ca-900364315-us"
}, {
    "recommendation": {},
    "storeNumber": "6512-60520",
    "id": "15200",
    "name": "Santa Monica & Fairfax",
    "phoneNumber": "323-822-9733",
    "coordinates": {
        "latitude": 34.091007,
        "longitude": -118.361711
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "7901 Santa Monica Blvd",
        "streetAddressLine2": "#107",
        "streetAddressLine3": "Santa Monica & Fairfax",
        "city": "West Hollywood",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900465177"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": true,
    "openStatusText": "Open until 6:00 PM",
    "addressLines": ["7901 Santa Monica Blvd", "#107", "West Hollywood, CA 90046"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "VS",
        "name": "Verismo"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "GO",
        "name": "Google Wi-Fi"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "MX",
        "name": "Music Experience"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "PS",
        "name": "Playbook Store System"
    }, {
        "code": "UE",
        "name": "tbd - Uber Eats"
    }],
    "slug": "santa-monica-fairfax-7901-santa-monica-blvd-santa-monica-fairfax-west-h"
}, {
    "recommendation": {},
    "storeNumber": "20540-196508",
    "id": "1007389",
    "name": "Ralph's - Los Angeles #198",
    "phoneNumber": "310-271-2672",
    "coordinates": {
        "latitude": 34.055004,
        "longitude": -118.39791
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "9616 W. Pico Blvd",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "Los Angeles",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "90035"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "LS",
    "open": true,
    "openStatusText": "Open until 9:00 PM",
    "addressLines": ["9616 W. Pico Blvd", "Los Angeles, CA 90035"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "6:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "6:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "6:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "6:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "6:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "6:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "6:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }],
    "slug": "ralphs-los-angeles-198-9616-w-pico-blvd-los-angeles-ca-90035-us"
}, {
    "recommendation": {},
    "storeNumber": "505-448",
    "id": "9033",
    "name": "N Beverly & S. Santa Monica Blvd",
    "phoneNumber": "(310) 271-1692",
    "coordinates": {
        "latitude": 34.070585,
        "longitude": -118.402361
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "428 North Beverly Drive",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "Beverly Hills",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "902104602"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": true,
    "openStatusText": "Open until 6:30 PM",
    "addressLines": ["428 North Beverly Drive", "Beverly Hills, CA 90210"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "6:00 AM to 6:30 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "6:00 AM to 6:15 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "6:00 AM to 6:15 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "VS",
        "name": "Verismo"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "GO",
        "name": "Google Wi-Fi"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "MX",
        "name": "Music Experience"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "PS",
        "name": "Playbook Store System"
    }, {
        "code": "UE",
        "name": "tbd - Uber Eats"
    }],
    "slug": "n-beverly-s-santa-monica-blvd-428-north-beverly-drive-beverly-hills-ca-902104602"
}, {
    "recommendation": {},
    "storeNumber": "5350-902",
    "id": "13332",
    "name": "Sunset Blvd & N. Kings Rd",
    "phoneNumber": "(323) 848-8663",
    "coordinates": {
        "latitude": 34.0957,
        "longitude": -118.372111
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "8363 N.E. Sunset Blvd.",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "West Hollywood",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900691515"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": true,
    "openStatusText": "Open until 6:00 PM",
    "addressLines": ["8363 N.E. Sunset Blvd.", "West Hollywood, CA 90069"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "GO",
        "name": "Google Wi-Fi"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "MX",
        "name": "Music Experience"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "PS",
        "name": "Playbook Store System"
    }, {
        "code": "UC",
        "name": "tbd - UCP"
    }, {
        "code": "UE",
        "name": "tbd - Uber Eats"
    }, {
        "code": "LU",
        "name": "Lunch"
    }],
    "slug": "sunset-blvd-n-kings-rd-8363-n-e-sunset-blvd-west-hollywood-ca-900691515-u"
}, {
    "recommendation": {},
    "storeNumber": "28278-245232",
    "id": "1016593",
    "name": "Ralphs - LA #291",
    "phoneNumber": "323-937-4107",
    "coordinates": {
        "latitude": 34.047531,
        "longitude": -118.339578
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "4760 W Pico Blvd",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "Los Angeles",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "90019"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "LS",
    "open": true,
    "openStatusText": "Open until 9:00 PM",
    "addressLines": ["4760 W Pico Blvd", "Los Angeles, CA 90019"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "6:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "6:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "6:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "6:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "6:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "6:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "6:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [],
    "slug": "ralphs-la-291-4760-w-pico-blvd-los-angeles-ca-90019-us"
}, {
    "recommendation": {},
    "storeNumber": "21467-212349",
    "id": "1006169",
    "name": "Target @ West Hollywood T-1884",
    "phoneNumber": "323-603-0004",
    "coordinates": {
        "latitude": 34.089763,
        "longitude": -118.344716
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "7100 Santa Monca Blvd, Suite 201",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "Los Angeles",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "90046"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "LS",
    "open": true,
    "openStatusText": "Open until 9:00 PM",
    "addressLines": ["7100 Santa Monca Blvd, Suite 201", "Los Angeles, CA 90046"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "7:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "7:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "8:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "8:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "8:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "8:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "8:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }],
    "slug": "target-west-hollywood-t-1884-7100-santa-monca-blvd-suite-201-los-angeles-ca-900"
}, {
    "recommendation": {},
    "storeNumber": "14629-128224",
    "id": "18591",
    "name": "Sunset & Crescent Heights",
    "phoneNumber": "323-656-1812",
    "coordinates": {
        "latitude": 34.09777,
        "longitude": -118.365224
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "8000 Sunset Blvd.",
        "streetAddressLine2": "B110",
        "streetAddressLine3": null,
        "city": "Los Angeles",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900462439"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": true,
    "openStatusText": "Open until 6:00 PM",
    "addressLines": ["8000 Sunset Blvd.", "B110", "Los Angeles, CA 90046"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "GO",
        "name": "Google Wi-Fi"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "MX",
        "name": "Music Experience"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "WC",
        "name": "Wireless Charging"
    }, {
        "code": "UE",
        "name": "tbd - Uber Eats"
    }],
    "slug": "sunset-crescent-heights-8000-sunset-blvd-los-angeles-ca-900462439-us"
}, {
    "recommendation": {},
    "storeNumber": "9506-95463",
    "id": "17873",
    "name": "Pico & San Vicente",
    "phoneNumber": "323-936-5032",
    "coordinates": {
        "latitude": 34.048457,
        "longitude": -118.337222
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "4700 West Pico Blvd",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "Los Angeles",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900194267"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": true,
    "openStatusText": "Open until 6:30 PM",
    "addressLines": ["4700 West Pico Blvd", "Los Angeles, CA 90019"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "6:00 AM to 6:30 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "6:00 AM to 6:30 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "6:00 AM to 6:30 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "6:00 AM to 6:30 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "6:00 AM to 6:30 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "6:00 AM to 6:30 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "6:00 AM to 6:30 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "WF",
        "name": "Wireless Hotspot"
    }, {
        "code": "VS",
        "name": "Verismo"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "MX",
        "name": "Music Experience"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "PS",
        "name": "Playbook Store System"
    }, {
        "code": "WC",
        "name": "Wireless Charging"
    }, {
        "code": "UC",
        "name": "tbd - UCP"
    }, {
        "code": "UE",
        "name": "tbd - Uber Eats"
    }],
    "slug": "pico-san-vicente-4700-west-pico-blvd-los-angeles-ca-900194267-us"
}, {
    "recommendation": {},
    "storeNumber": "6729-74640",
    "id": "12058",
    "name": "Santa Monica & La Brea",
    "phoneNumber": "323-874-2135",
    "coordinates": {
        "latitude": 34.090357,
        "longitude": -118.344252
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "7100 Santa Monica Blvd",
        "streetAddressLine2": "Suite 140",
        "streetAddressLine3": "West Hollywood Gateway",
        "city": "West Hollywood",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900465896"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": true,
    "openStatusText": "Open until 6:00 PM",
    "addressLines": ["7100 Santa Monica Blvd", "Suite 140", "West Hollywood, CA 90046"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "WF",
        "name": "Wireless Hotspot"
    }, {
        "code": "VS",
        "name": "Verismo"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "MX",
        "name": "Music Experience"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "PS",
        "name": "Playbook Store System"
    }, {
        "code": "WC",
        "name": "Wireless Charging"
    }, {
        "code": "UE",
        "name": "tbd - Uber Eats"
    }],
    "slug": "santa-monica-la-brea-7100-santa-monica-blvd-west-hollywood-gateway-west"
}, {
    "recommendation": {},
    "storeNumber": "22601-215486",
    "id": "1007178",
    "name": "Highland & Willoughby",
    "phoneNumber": "323-493-1868",
    "coordinates": {
        "latitude": 34.086929,
        "longitude": -118.338858
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "859 N. Highland Avenue",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "Los Angeles",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900383416"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": true,
    "openStatusText": "Open until 11:00 PM",
    "addressLines": ["859 N. Highland Avenue", "Los Angeles, CA 90038"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "5:00 AM to 11:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "5:00 AM to 8:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "5:00 AM to 8:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "5:00 AM to 8:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "5:00 AM to 8:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "5:00 AM to 8:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "5:00 AM to 8:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "DT",
        "name": "Drive-Thru"
    }, {
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "GO",
        "name": "Google Wi-Fi"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "MX",
        "name": "Music Experience"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "SQ",
        "name": "tbd"
    }, {
        "code": "RW",
        "name": "My Starbucks Rewards"
    }, {
        "code": "PS",
        "name": "Playbook Store System"
    }],
    "slug": "highland-willoughby-859-n-highland-avenue-los-angeles-ca-900383416-us"
}, {
    "recommendation": {},
    "storeNumber": "5401-721",
    "id": "13341",
    "name": "Wilshire & Santa Monica",
    "phoneNumber": "(310) 552-3133",
    "coordinates": {
        "latitude": 34.066665,
        "longitude": -118.410299
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "9811 S. Santa Monica Blvd",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "Beverly Hills",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "902121604"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": true,
    "openStatusText": "Open until 6:00 PM",
    "addressLines": ["9811 S. Santa Monica Blvd", "Beverly Hills, CA 90212"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "CL",
        "name": "Starbucks Reserve-Clover Brewed"
    }, {
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "WF",
        "name": "Wireless Hotspot"
    }, {
        "code": "VS",
        "name": "Verismo"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "PS",
        "name": "Playbook Store System"
    }, {
        "code": "WC",
        "name": "Wireless Charging"
    }, {
        "code": "UE",
        "name": "tbd - Uber Eats"
    }],
    "slug": "wilshire-santa-monica-9811-s-santa-monica-blvd-beverly-hills-ca-90212160"
}, {
    "recommendation": {},
    "storeNumber": "21866-169146",
    "id": "1006810",
    "name": "Ralph's- Hollywood, CA #100",
    "phoneNumber": "323-512-8382",
    "coordinates": {
        "latitude": 34.098715,
        "longitude": -118.348393
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "7257 W Sunset Blvd",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "Los Angeles",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900463409"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "LS",
    "open": true,
    "openStatusText": "Open until 9:00 PM",
    "addressLines": ["7257 W Sunset Blvd", "Los Angeles, CA 90046"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "5:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "5:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "5:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "5:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "5:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "5:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "5:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }],
    "slug": "ralphs-hollywood-ca-100-7257-w-sunset-blvd-los-angeles-ca-900463409-us"
}, {
    "recommendation": {},
    "storeNumber": "9228-279424",
    "id": "1025847",
    "name": "2049 Century Park East & Olympic",
    "phoneNumber": "2133939132",
    "coordinates": {
        "latitude": 34.059002,
        "longitude": -118.41325
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "2049 Century Park East",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "Century City",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "90067"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": false,
    "openStatusText": "Closed",
    "addressLines": ["2049 Century Park East", "Century City, CA 90067"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "Closed",
        "open": false,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "Closed",
        "open": false,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "4:30 AM to 3:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "4:30 AM to 3:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "4:30 AM to 3:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "4:30 AM to 3:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "4:30 AM to 3:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "WF",
        "name": "Wireless Hotspot"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "MX",
        "name": "Music Experience"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "PS",
        "name": "Playbook Store System"
    }, {
        "code": "WC",
        "name": "Wireless Charging"
    }, {
        "code": "UE",
        "name": "tbd - Uber Eats"
    }],
    "slug": "2049-century-park-east-olympic-2049-century-park-east-century-city-ca-90067-us"
}, {
    "recommendation": {},
    "storeNumber": "9232-9081",
    "id": "11138",
    "name": "Watt Plaza",
    "phoneNumber": "(310) 553-8226",
    "coordinates": {
        "latitude": 34.061035,
        "longitude": -118.414937
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "1875 Century Park East",
        "streetAddressLine2": null,
        "streetAddressLine3": "Watt Plaza Towers",
        "city": "Century City",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900672337"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": false,
    "openStatusText": "Closed",
    "addressLines": ["1875 Century Park East", "Century City, CA 90067"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "Closed",
        "open": false,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "Closed",
        "open": false,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "5:00 AM to 3:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "5:00 AM to 3:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "5:00 AM to 3:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "5:00 AM to 3:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "5:00 AM to 3:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "VS",
        "name": "Verismo"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "GO",
        "name": "Google Wi-Fi"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "MX",
        "name": "Music Experience"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "PS",
        "name": "Playbook Store System"
    }, {
        "code": "WC",
        "name": "Wireless Charging"
    }, {
        "code": "UE",
        "name": "tbd - Uber Eats"
    }],
    "slug": "watt-plaza-1875-century-park-east-watt-plaza-towers-century-c"
}, {
    "recommendation": {},
    "storeNumber": "5402-1195",
    "id": "11568",
    "name": "Sunset & La Brea",
    "phoneNumber": "(323) 469-6994",
    "coordinates": {
        "latitude": 34.098151,
        "longitude": -118.343531
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "7055 SUNSET BLVD",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "Los Angeles",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900287509"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": true,
    "openStatusText": "Open until 6:00 PM",
    "addressLines": ["7055 SUNSET BLVD", "Los Angeles, CA 90028"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "VS",
        "name": "Verismo"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "GO",
        "name": "Google Wi-Fi"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "MX",
        "name": "Music Experience"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "PS",
        "name": "Playbook Store System"
    }, {
        "code": "WC",
        "name": "Wireless Charging"
    }, {
        "code": "UE",
        "name": "tbd - Uber Eats"
    }],
    "slug": "sunset-la-brea-7055-sunset-blvd-los-angeles-ca-900287509-us"
}, {
    "recommendation": {},
    "storeNumber": "507-450",
    "id": "9035",
    "name": "Larchmont & Beverly",
    "phoneNumber": "323-469-1081",
    "coordinates": {
        "latitude": 34.074908,
        "longitude": -118.323461
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "206 North Larchmont",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "Los Angeles",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900043707"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": true,
    "openStatusText": "Open until 6:00 PM",
    "addressLines": ["206 North Larchmont", "Los Angeles, CA 90004"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "VS",
        "name": "Verismo"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "GO",
        "name": "Google Wi-Fi"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "MX",
        "name": "Music Experience"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "PS",
        "name": "Playbook Store System"
    }, {
        "code": "WC",
        "name": "Wireless Charging"
    }, {
        "code": "UE",
        "name": "tbd - Uber Eats"
    }],
    "slug": "larchmont-beverly-206-north-larchmont-los-angeles-ca-900043707-us"
}, {
    "recommendation": {},
    "storeNumber": "14412-118485",
    "id": "18674",
    "name": "La Cienega & Jefferson",
    "phoneNumber": "323-938-0821",
    "coordinates": {
        "latitude": 34.026772,
        "longitude": -118.371795
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "3344 S. La Cienega Blvd",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "Los Angeles",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900163115"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": true,
    "openStatusText": "Open until 7:00 PM",
    "addressLines": ["3344 S. La Cienega Blvd", "Los Angeles, CA 90016"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "6:00 AM to 7:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "6:00 AM to 7:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "6:00 AM to 7:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "6:00 AM to 7:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "6:00 AM to 7:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "6:00 AM to 7:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "6:00 AM to 7:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "GO",
        "name": "Google Wi-Fi"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "MX",
        "name": "Music Experience"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "PS",
        "name": "Playbook Store System"
    }, {
        "code": "WC",
        "name": "Wireless Charging"
    }, {
        "code": "UE",
        "name": "tbd - Uber Eats"
    }],
    "slug": "la-cienega-jefferson-3344-s-la-cienega-blvd-los-angeles-ca-900163115-us"
}, {
    "recommendation": {},
    "storeNumber": "74586-39039",
    "id": "16222",
    "name": "Vons-Los Angeles #2229",
    "phoneNumber": "3234614167",
    "coordinates": {
        "latitude": 34.084362,
        "longitude": -118.326967
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "727 N Vine St",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "Los Angeles",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900383713"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "LS",
    "open": true,
    "openStatusText": "Open until 11:00 PM",
    "addressLines": ["727 N Vine St", "Los Angeles, CA 90038"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "5:30 AM to 11:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "5:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "5:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "5:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "5:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "5:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "5:30 AM to 11:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "BA",
        "name": "Bakery"
    }, {
        "code": "RW",
        "name": "My Starbucks Rewards"
    }],
    "slug": "vons-los-angeles-2229-727-n-vine-st-los-angeles-ca-900383713-us"
}, {
    "recommendation": {},
    "storeNumber": "9505-96843",
    "id": "7663",
    "name": "Crenshaw & Washington, Los Angeles",
    "phoneNumber": "323-734-0281",
    "coordinates": {
        "latitude": 34.040151,
        "longitude": -118.330501
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "4177 W. Washington Blvd.",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "Los Angeles",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900181055"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": true,
    "openStatusText": "Open until 12:00 AM",
    "addressLines": ["4177 W. Washington Blvd.", "Los Angeles, CA 90018"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "4:00 AM to 12:00 AM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "4:00 AM to 12:00 AM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "4:00 AM to 12:00 AM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "4:00 AM to 12:00 AM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "4:00 AM to 12:00 AM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "4:00 AM to 12:00 AM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "4:00 AM to 12:00 AM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "DT",
        "name": "Drive-Thru"
    }, {
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "GO",
        "name": "Google Wi-Fi"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "MX",
        "name": "Music Experience"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "PS",
        "name": "Playbook Store System"
    }, {
        "code": "WC",
        "name": "Wireless Charging"
    }, {
        "code": "UC",
        "name": "tbd - UCP"
    }, {
        "code": "UE",
        "name": "tbd - Uber Eats"
    }],
    "slug": "crenshaw-washington-los-angeles-4177-w-washington-blvd-los-angeles-ca-900181055-us"
}, {
    "recommendation": {},
    "storeNumber": "76949-131627",
    "id": "7848",
    "name": "Target Los Angeles T-1306",
    "phoneNumber": "(310) 895-1131",
    "coordinates": {
        "latitude": 34.023407,
        "longitude": -118.373792
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "3535 S La Cienega Blvd",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "Los Angeles",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900164407"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "LS",
    "open": true,
    "openStatusText": "Open until 10:00 PM",
    "addressLines": ["3535 S La Cienega Blvd", "Los Angeles, CA 90016"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "8:00 AM to 10:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "8:00 AM to 10:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "8:00 AM to 10:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "8:00 AM to 10:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "8:00 AM to 10:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "8:00 AM to 10:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "8:00 AM to 10:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }],
    "slug": "target-los-angeles-t-1306-3535-s-la-cienega-blvd-los-angeles-ca-900164407-us"
}, {
    "recommendation": {},
    "storeNumber": "52258-279471",
    "id": "1024860",
    "name": "Santa Monica & Vine",
    "phoneNumber": "3238714171",
    "coordinates": {
        "latitude": 34.090389,
        "longitude": -118.32626
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "6260 Santa Monica Blvd",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "Los Angeles",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900381704"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": true,
    "openStatusText": "Open until 6:00 PM",
    "addressLines": ["6260 Santa Monica Blvd", "Los Angeles, CA 90038"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "GO",
        "name": "Google Wi-Fi"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "RW",
        "name": "My Starbucks Rewards"
    }, {
        "code": "PS",
        "name": "Playbook Store System"
    }, {
        "code": "CS",
        "name": "tbd - Coffee Scale"
    }],
    "slug": "santa-monica-vine-6260-santa-monica-blvd-los-angeles-ca-900381704-us"
}, {
    "recommendation": {},
    "storeNumber": "5250-901",
    "id": "13312",
    "name": "Venice & Culver",
    "phoneNumber": "(310) 558-0407",
    "coordinates": {
        "latitude": 34.027136,
        "longitude": -118.392767
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "8985 Venice Blvd",
        "streetAddressLine2": "Ste CB-2",
        "streetAddressLine3": "Venice Crossroads Shopping Center",
        "city": "Los Angeles",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900343344"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": true,
    "openStatusText": "Open until 6:00 PM",
    "addressLines": ["8985 Venice Blvd", "Ste CB-2", "Los Angeles, CA 90034"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "WF",
        "name": "Wireless Hotspot"
    }, {
        "code": "VS",
        "name": "Verismo"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "MX",
        "name": "Music Experience"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "PS",
        "name": "Playbook Store System"
    }, {
        "code": "WC",
        "name": "Wireless Charging"
    }, {
        "code": "UE",
        "name": "tbd - Uber Eats"
    }],
    "slug": "venice-culver-8985-venice-blvd-venice-crossroads-shopping-center"
}, {
    "recommendation": {},
    "storeNumber": "6451-54039",
    "id": "9247",
    "name": "National & Castle Heights",
    "phoneNumber": "310-839-1483",
    "coordinates": {
        "latitude": 34.03105,
        "longitude": -118.400976
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "9824 National Blvd",
        "streetAddressLine2": null,
        "streetAddressLine3": "Cheviot Hills Shopping Center",
        "city": "Los Angeles",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900342739"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": true,
    "openStatusText": "Open until 6:00 PM",
    "addressLines": ["9824 National Blvd", "Los Angeles, CA 90034"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "VS",
        "name": "Verismo"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "GO",
        "name": "Google Wi-Fi"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "MX",
        "name": "Music Experience"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "PS",
        "name": "Playbook Store System"
    }, {
        "code": "WC",
        "name": "Wireless Charging"
    }, {
        "code": "UE",
        "name": "tbd - Uber Eats"
    }],
    "slug": "national-castle-heights-9824-national-blvd-cheviot-hills-shopping-center-l"
}, {
    "recommendation": {},
    "storeNumber": "21687-212688",
    "id": "1006804",
    "name": "Ralphs - Los Angeles #283",
    "phoneNumber": "323-292-0633",
    "coordinates": {
        "latitude": 34.020441,
        "longitude": -118.35481
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "5080 Obama Blvd",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "Los Angeles",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "90016"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "LS",
    "open": true,
    "openStatusText": "Open until 9:00 PM",
    "addressLines": ["5080 Obama Blvd", "Los Angeles, CA 90016"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "6:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "6:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "6:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "6:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "6:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "6:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "6:00 AM to 9:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }],
    "slug": "ralphs-los-angeles-283-5080-obama-blvd-los-angeles-ca-90016-us"
}, {
    "recommendation": {},
    "storeNumber": "5620-1957",
    "id": "9159",
    "name": "Highland & Franklin",
    "phoneNumber": "323-850-7360",
    "coordinates": {
        "latitude": 34.105349,
        "longitude": -118.336826
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "1900 N Highland",
        "streetAddressLine2": "#1",
        "streetAddressLine3": null,
        "city": "Hollywood",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900682997"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": true,
    "openStatusText": "Open until 6:00 PM",
    "addressLines": ["1900 N Highland", "#1", "Hollywood, CA 90068"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "WF",
        "name": "Wireless Hotspot"
    }, {
        "code": "VS",
        "name": "Verismo"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "MX",
        "name": "Music Experience"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "PS",
        "name": "Playbook Store System"
    }, {
        "code": "UE",
        "name": "tbd - Uber Eats"
    }],
    "slug": "highland-franklin-1900-n-highland-hollywood-ca-900682997-us"
}, {
    "recommendation": {},
    "storeNumber": "22916-225624",
    "id": "1007064",
    "name": "Sunset & Vine",
    "phoneNumber": "323-464-1859",
    "coordinates": {
        "latitude": 34.097837,
        "longitude": -118.326437
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "6290 Sunset Blvd.",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "Hollywood",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900288711"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": true,
    "openStatusText": "Open until 6:00 PM",
    "addressLines": ["6290 Sunset Blvd.", "Hollywood, CA 90028"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "CL",
        "name": "Starbucks Reserve-Clover Brewed"
    }, {
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "WF",
        "name": "Wireless Hotspot"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "GO",
        "name": "Google Wi-Fi"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "MX",
        "name": "Music Experience"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "SQ",
        "name": "tbd"
    }, {
        "code": "RW",
        "name": "My Starbucks Rewards"
    }, {
        "code": "PS",
        "name": "Playbook Store System"
    }, {
        "code": "CS",
        "name": "tbd - Coffee Scale"
    }, {
        "code": "WC",
        "name": "Wireless Charging"
    }, {
        "code": "UE",
        "name": "tbd - Uber Eats"
    }],
    "slug": "sunset-vine-6290-sunset-blvd-hollywood-ca-900288711-us"
}, {
    "recommendation": {},
    "storeNumber": "5771-15093",
    "id": "15444",
    "name": "Washington & Culver",
    "phoneNumber": "310-204-1075",
    "coordinates": {
        "latitude": 34.022193,
        "longitude": -118.39623
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "9718 Washington Blvd.",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "Culver City",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "902322722"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": true,
    "openStatusText": "Open until 6:00 PM",
    "addressLines": ["9718 Washington Blvd.", "Culver City, CA 90232"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "VS",
        "name": "Verismo"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "GO",
        "name": "Google Wi-Fi"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "MX",
        "name": "Music Experience"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "PS",
        "name": "Playbook Store System"
    }, {
        "code": "UE",
        "name": "tbd - Uber Eats"
    }],
    "slug": "washington-culver-9718-washington-blvd-culver-city-ca-902322722-us"
}, {
    "recommendation": {},
    "storeNumber": "5461-1452",
    "id": "9353",
    "name": "Sunset & Gower",
    "phoneNumber": "(323) 467-6404",
    "coordinates": {
        "latitude": 34.097346,
        "longitude": -118.322498
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "6102 W. Sunset Blvd.",
        "streetAddressLine2": "Unit 6102",
        "streetAddressLine3": null,
        "city": "Los Angeles",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900286424"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": true,
    "openStatusText": "Open until 6:00 PM",
    "addressLines": ["6102 W. Sunset Blvd.", "Unit 6102", "Los Angeles, CA 90028"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "5:30 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "5:30 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "5:30 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "5:30 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "5:30 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "5:30 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "5:30 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "WF",
        "name": "Wireless Hotspot"
    }, {
        "code": "VS",
        "name": "Verismo"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "MX",
        "name": "Music Experience"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "PS",
        "name": "Playbook Store System"
    }, {
        "code": "WC",
        "name": "Wireless Charging"
    }, {
        "code": "UE",
        "name": "tbd - Uber Eats"
    }],
    "slug": "sunset-gower-6102-w-sunset-blvd-los-angeles-ca-900286424-us"
}, {
    "recommendation": {},
    "storeNumber": "16980-167664",
    "id": "90032",
    "name": "Hollywood & Vine",
    "phoneNumber": "323-464-4601",
    "coordinates": {
        "latitude": 34.101461,
        "longitude": -118.326497
    },
    "regulations": [],
    "address": {
        "streetAddressLine1": "6290 West Hollywood Blvd",
        "streetAddressLine2": null,
        "streetAddressLine3": null,
        "city": "Hollywood",
        "countrySubdivisionCode": "CA",
        "countryCode": "US",
        "postalCode": "900285309"
    },
    "timeZoneInfo": {
        "currentTimeOffset": -420,
        "windowsTimeZoneId": "Pacific Standard Time",
        "olsonTimeZoneId": "GMT-08:00 America/Los_Angeles"
    },
    "brandName": "Starbucks",
    "ownershipTypeCode": "CO",
    "open": true,
    "openStatusText": "Open until 6:00 PM",
    "addressLines": ["6290 West Hollywood Blvd", "Hollywood, CA 90028"],
    "mop": {
        "ready": false,
        "wait": null
    },
    "schedule": [{
        "dayName": "Today",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tomorrow",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Monday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Tuesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Wednesday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Thursday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }, {
        "dayName": "Friday",
        "hours": "6:00 AM to 6:00 PM",
        "open": true,
        "holiday": ""
    }],
    "features": [{
        "code": "WA",
        "name": "Oven-warmed Food"
    }, {
        "code": "WF",
        "name": "Wireless Hotspot"
    }, {
        "code": "CD",
        "name": "Mobile Payment"
    }, {
        "code": "DR",
        "name": "Digital Rewards"
    }, {
        "code": "LB",
        "name": "LaBoulange"
    }, {
        "code": "XO",
        "name": "Mobile Order and Pay"
    }, {
        "code": "MX",
        "name": "Music Experience"
    }, {
        "code": "NB",
        "name": "Nitro Cold Brew"
    }, {
        "code": "BE",
        "name": "Blonde Espresso"
    }, {
        "code": "LU",
        "name": "Lunch"
    }, {
        "code": "RW",
        "name": "My Starbucks Rewards"
    }, {
        "code": "PS",
        "name": "Playbook Store System"
    }, {
        "code": "WC",
        "name": "Wireless Charging"
    }, {
        "code": "UE",
        "name": "tbd - Uber Eats"
    }],
    "slug": "hollywood-vine-6290-west-hollywood-blvd-hollywood-ca-900285309-us"
}]

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs-section"] && !Shopify.designMode) return;
  try {
    
  // tabs

var tabLinks = document.querySelectorAll(".tablinks");
var tabContent = document.querySelectorAll(".tabcontent");


tabLinks.forEach(function(el) {
   el.addEventListener("click", openTabs);
});


function openTabs(el) {
   var btnTarget = el.currentTarget;
   var country = btnTarget.dataset.country;

   tabContent.forEach(function(el) {
      el.classList.remove("active");
   });

   tabLinks.forEach(function(el) {
      el.classList.remove("active");
   });

   document.querySelector("#" + country).classList.add("active");
   
   btnTarget.classList.add("active");
}
$(document).ready(function(){
 $('.tabsBtn.tabBtn1').addClass('active');
  
  $('#shipping-amp-returns .tabsBtn.tabBtn6').addClass('active');
  $('#shipping-amp-returns .tabsBtn.tabBtn6').trigger('click');
  $('#shipping-amp-returns .tabsBtn.tabBtn1').removeClass('active'); 
  
 
  

  $('.expand_all').on('click', function(){
      if($('.faq').hasClass('active')){
        $('.faq').removeClass('active');
      }else{
        $('.faq').addClass('active');
      }
      
  });
 $('.tabsBtn').click(function() {
  if ($(this).hasClass('active')) {
    $(this).removeClass('active');
  } else {
    $(this).addClass('active');
    $(this).siblings().removeClass('active');
  }
});


  // Accordian Fucnction
$('.tab-content').addClass('hide');
  $('.tab-content.tab1').removeClass('hide');
  $('.tab-content.tab1').addClass('show');
   $('#shipping-amp-returns .tab-content.tab2').removeClass('hide');
   $('#shipping-amp-returns .tab-content.tab2').addClass('show');
  $('#shipping-amp-returns .tab-content.tab1').addClass('hide');
  $('#shipping-amp-returns .tab-content.tab1').removeClass('show');
  
  $('.tabsBtn').each(function() {
    var tabId = $(this).data('id');
    $(this).on('click', function() {
      $('.tab-content').each(function() {
        var faqId = $(this).data('id');
        if (tabId === faqId) {
          $(this).addClass('show').removeClass('hide');
        } else {
          $(this).addClass('hide').removeClass('show');
        }
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
